
let exhibition = 'teet'
let exhibition_id = 14
let all_exhibition_id = '21,23,25,31,33,34,42,41,43,45,46,50,51,52,53,54,55,56,57,58,59,60,64,72,74'




export { exhibition, exhibition_id, all_exhibition_id }


// WEBPACK FOOTER //
// ./src/utils/exhibitId.js